<div>
   <quill-editor [(ngModel)]="editor_content"
    [modules]="modules"
    [required]="true"
    (onEditorCreated)="EditorCreated($event)"
    [placeholder]="'Insert text here ...'"
    [styles]="{'min-height':'300px', 'width':'100%'}">
  </quill-editor>
</div>
